import { CustomerDetailsState } from '../states/customer-details.state';
import { CustomerDetailsAction, CustomerDetailsActionTypes } from '../actions/customer-details.actions';

 function getInitialState (): CustomerDetailsState {
    return {
      customerDetails : {
        persona: '',
        customerType: null,
        processType: null,
      },
      cancellationReason: '',
      xConversationId: '',
      isAccountAgent:  false,
      downloadedStatus: {
        qrCode: {
            email: null,
            direct: null,
        },
        freightLabel: {
            email: null,
            direct: null,
        },
      },

    };
  }

/** CustomerDetailsReducer */
export function CustomerDetailsReducer (state: CustomerDetailsState = getInitialState (), action: CustomerDetailsAction): CustomerDetailsState {
    /* SELECT OPTION PICKER LANDING PAGE TO UPDATE STATE */
    switch (action.type) {
        case CustomerDetailsActionTypes.SET_CUSTOMER_DETAILS:
            return { ...state,
                customerDetails: action.payload.customerDetails,
            };
        case CustomerDetailsActionTypes.CHOSSE_REASON:
            return { ...state, cancellationReason : action.payload.cancellationReason };
        case CustomerDetailsActionTypes.DOWNLOAD_STATUS:
            return { ...state, downloadedStatus : action.payload.downloadedStatus };
        case CustomerDetailsActionTypes.SET_XCONNERSATION_ID:
            return { ...state, xConversationId : action.payload.xConversationId };
        case CustomerDetailsActionTypes.RESET_SELECTION:
            return new CustomerDetailsState();
        case CustomerDetailsActionTypes.RESET_DOWNLOAD_STATUS:
            return { ...state, downloadedStatus :  getInitialState().downloadedStatus};
        case CustomerDetailsActionTypes.ACCOUNT_AGENT_STATUS:
            return { ...state, isAccountAgent : action.payload.isAccountAgent};
        default:
            return state;
    }
}
